<template>
    <div class="pix-payment-form">
        <!-- Desktop -->
        <div class="row d-none d-md-flex">
            <div class="col-9 d-flex align-items-center">
                <div class="row d-flex justify-content-center">
                    <div class="col-9">
                        <div class="row mb-2">
                            <div class="col-1 d-flex flex-column justify-content-center">
                                <hr class="m-0">
                            </div>
                            <div class="col-2 d-flex justify-content-center">
                                <div class="item-icon">1</div>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center">
                                <hr class="m-0">
                            </div>
                            <div class="col-2 d-flex justify-content-center">
                                <div class="item-icon">2</div>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center">
                                <hr class="m-0">
                            </div>
                            <div class="col-2 d-flex justify-content-center">
                                <div class="item-icon">3</div>
                            </div>
                            <div class="col-1 d-flex flex-column justify-content-center">
                                <hr class="m-0">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 text-align-center">
                                Abra o aplicativo do seu banco e escolha a opção PIX
                            </div>
                            <div class="col-4 text-align-center">
                                Copie e cole o código ou use a câmera do celular para ler o QR Code
                            </div>
                            <div class="col-4 text-align-center">
                                Verifique as informações e finalize o pagamento pelo aplicativo do banco
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="payment.pix.code != ''" class="col-3">
                <div class="code">
                    <qr-code :value="payment.pix.code"></qr-code>
                </div>
                <div class="row">
                    <div class="col-6">
                        <button @click="close()" class="btn btn-dark btn-block"> VOLTAR </button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-primary btn-block" @click="copy"> {{ copyText }} </button>
                    </div>
                </div>
            </div>
            <div v-else class="col-3 d-flex flex-column justify-content-end">
                <div class="row">
                    <div class="col-6">
                        <button @click="close()" id="generateButton" class="btn btn-dark btn-block"  :disabled="loading"> Voltar </button>
                    </div>
                    <div class="col-6">
                        <button v-if="!loading" @click="submit()" id="generateButton" class="btn btn-primary btn-block"> Gerar PIX </button>
                        <button v-else class="btn btn-block btn-primary fill-height" disabled>
                            <div class="spinner-border spinner-border-sm text-light small" role="status"></div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Mobile -->
        <div class="row d-flex d-md-none">
            <div class="col-12">
                <div class="row d-flex justify-content-center">
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                    <div class="col-4 d-flex justify-content-center">
                        <div class="item-icon">1</div>
                    </div>
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                </div>
                <div class="row text-align-center my-3">
                    <div class="col-12">
                        Abra o aplicativo do seu banco e escolha a opção PIX
                    </div>
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                    <div class="col-4 d-flex justify-content-center">
                        <div class="item-icon">2</div>
                    </div>
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                </div>
                <div class="row text-align-center my-3">
                    <div class="col-12">
                        Copie e cole o código ou use a câmera do celular para ler o QR Code
                    </div>
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                    <div class="col-4 d-flex justify-content-center">
                        <div class="item-icon">3</div>
                    </div>
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                </div>
                <div class="row text-align-center my-3">
                    <div class="col-12">
                        Verifique as informações e finalize o pagamento pelo aplicativo do banco
                    </div>
                </div>
            </div>
            <div v-if="payment.pix.code != ''" class="col-12">
                <div class="code d-flex justify-content-center">
                    <qr-code :value="payment.pix.code"></qr-code>
                </div>
                <div class="row">
                    <div class="col-6">
                        <button @click="close()" class="btn btn-dark btn-block"> VOLTAR </button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-primary btn-block" @click="copy"> {{ copyText }} </button>
                    </div>
                </div>
            </div>
            <div v-else class="col-12 d-flex flex-column justify-content-end">
                <div class="row">
                    <div class="col-6">
                        <button @click="close()" id="generateButton" class="btn btn-dark btn-block" :disabled="loading"> VOLTAR </button>
                    </div>
                    <div class="col-6">
                        <button v-if="!loading" @click="submit()" id="generateButton" class="btn btn-primary btn-block"> GERAR PIX </button>
                        <button v-else class="btn btn-block btn-primary fill-height" disabled>
                            <div class="spinner-border spinner-border-sm text-light small" role="status"></div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import QrCode from '../../utils/qrcode.vue'
import recaptcha from '../../../plugins/recaptcha'

export default Vue.extend({
    data() {
        return {
            blur: true,
            copyText: 'Copiar',
            payment: {
                pix: {
                    code: ''
                }
            },
            loading: false,
        }
    },
    components: {
        QrCode
    },
    props: {
        cart: {
            required: true,
            type: Object
        },
        error: {
            required: true,
            type: Object
        },
    },
    methods: {
        generate() {
            this.blur = false
            this.value = '123123178231'
        },
        close() {
            this.$emit('close')
        },
        async submit() {
            try {
                this.loading = true

                const token = await recaptcha()

                const response = await axios.post('/api/payment/pay', {
                    cart: this.cart,
                    type: 'pix',
                    token: token
                });

                const payment = response.data.payment 

                this.payment.generated = true
                this.payment.pix.code = payment.data.br_code
                this.payment.pix.txid = payment.data.txid
                this.payment.pix.expiration = window.luxon.fromISO(payment.data.expiration_date)

                // Implementação com Websockets, comentada aqui porque ainda não consegui passar isso 
                // para o ambiente de produção
                // this.channels.pix = window.Echo.private('App.User.Pix.{{Auth::user()->id}}')
                // this.channels.pix.listen('PixReceived', (e) => {
                //     console.log('Recebeu websocket')
                //     this.$emit("success")
                // })

                // Implementação com HTTP, remover assim que o websocket começar a funcionar
                setInterval(
                    async () => {
                        try {
                            const response = await axios.get(`/api/payment/pix/status/${this.payment.pix.txid}`)

                            if (response.data.data.received) {
                                this.$emit("success")
                            }
                        } catch (e) {
                            console.log(e)
                        }
                    },
                    6000
                )
            } catch (error) {
                this.error.condition = true
                this.error.message = error.response.data.message
            }
            this.loading = false
            this.$emit('submit')
        },
        copy() {
            window.navigator.clipboard.writeText(this.payment.pix.code)
            this.copyText = 'Copiado!'
            setTimeout(() => this.copyText = 'Copiar', 5000)
        }
    }
})
</script>

<style scoped>
    .blur {
        filter: blur(2px);
    }

    ol {
        padding-left: 1rem;
        margin-bottom: 0;
    }
    
    .text-align-center {
        text-align: center;
    }
</style>